export default __webpack_public_path__ + "static/media/users.13ea4300.svg";